module.exports = __webpack_public_path__ + "img/slider-shop-image-mobile.1009e99e.png";